import { Component, OnInit } from '@angular/core';
import { NewProductSlider } from 'src/app/shared/data/slider';

@Component({
  selector: 'app-Market',
  templateUrl: './Market.component.html',
  styleUrls: ['./Market.component.scss']
})
export class MarketComponent implements OnInit {

  title="Markets"
  public NewProductSliderConfig: any = NewProductSlider;

  markets=[
    {
      link:'https://www.amazon.com',
      img:'assets/images/parteners/0020.png'
    },
    {
      link:'https://www.ebay.com',
      img:'assets/images/parteners/00.jpg'
    },
    {
      link:'https://www.macys.com',
      img:'assets/images/parteners/001.jpg'
    },
    {
      link:'https://www.nordstrom.com',
      img:'assets/images/parteners/002.jpg'
    },
    {
      link:'https://www.sephora.com',
      img:'assets/images/parteners/003.jpg'
    },
    {
      link:'https://www.walmart.com',
      img:'assets/images/parteners/004.jpg'
    },
    {
      link:'https://www.adidas.com/us',
      img:'assets/images/parteners/005.jpg'
    },
    {
      link:'https://www.nike.com',
      img:'assets/images/parteners/006.jpg'
    },
    {
      link:'https://www.target.com',
      img:'assets/images/parteners/007.jpg'
    },
    {
      link:'https://www.underarmour.com/en-us',
      img:'assets/images/parteners/008.jpg'
    },

    {
      link:'https://www.6pm.com',
      img:'assets/images/parteners/0011.jpg'
    },
    {
      link:'https://www.guess.com',
      img:'assets/images/parteners/0012.jpg'
    },
    {
      link:'https://www.michaelkors.com',
      img:'assets/images/parteners/0013.jpg'
    },
    {
      link:'https://www.ralphlauren.com',
      img:'assets/images/parteners/0014.jpg'
    },
    {
      link:'https://www.nordstromrack.com',
      img:'assets/images/parteners/0015.jpg'
    },
    {
      link:'https://www.shein.com',
      img:'assets/images/parteners/0016.jpg'
    },
    {
      link:'https://www.fashionnova.com/',
      img:'assets/images/parteners/0017.jpg'
    },
    {
      link:'https://www.uniformadvantage.com',
      img:'assets/images/parteners/0018.jpg'
    },
    {
      link:'https://www.victoriassecret.com',
      img:'assets/images/parteners/0019.jpg'
    },

    {
      link:'https://www.aldoshoes.com',
      img:'assets/images/parteners/0021.jpg'
    },
  ]


  constructor() { }

  ngOnInit() {
    
  }

  webLink(link: string):string
  {
    var firstDot =link.indexOf('.');
    var lastDot =link.lastIndexOf('.');
    var getName = link.substring(firstDot+1,lastDot);
    return getName.toUpperCase();
  }
}
